export default "__VITE_ASSET__4J8QwlNi__"